/**
 * All that the user interacts with.
 * @module UserInterface
 * @category Display Components
 */

import { IsInPortrait } from "../state/selectors";
import UserInterfaceLandscape from "./UserInterfaceLandscape";
import { UserInterfacePortrait } from "./UserInterfacePortrait";
import { useRecoilValue } from "recoil";

/**
 * @@export UserInterface
 */
function UserInterface() {
	const isInPortrait = useRecoilValue(IsInPortrait);

	if (isInPortrait) {
		// mobile view
		return <UserInterfacePortrait />;
	}
	return <UserInterfaceLandscape />;
}

export { UserInterface };
